import { handleChangeNumInputNoDecimalsMinMax } from '../../../helpers/helpers';
import { AdminDollarInput2 } from '../../AdminDollarInput/AdminDollarInput2';
import { AdminInput } from '../../AdminInput/AdminInput';

/**
 * Money is held in cents end to end, which is exactly what this input works in
 * - no conversion. It renders 0 as an empty field, so 0 and "unset" are the
 * same thing here: a $0 flat fee is no flat fee, and a 0 upper bound is no
 * upper bound. Callers that need a real 0 (a tier's lower bound) coerce it.
 */
export const MoneyInput = ({
  label,
  value,
  onChange,
  placeholder,
  disabled,
}: {
  label: string;
  value: number | null;
  onChange: (cents: number | null) => void;
  placeholder?: string;
  disabled?: boolean;
}) => (
  <AdminDollarInput2
    label={label}
    placeholder={placeholder}
    $textCenter
    disabled={disabled}
    value={value ?? 0}
    onValueChange={(cents: number) => onChange(cents === 0 ? null : cents)}
    onClickClear={!disabled && value ? () => onChange(null) : undefined}
  />
);

export const PercentageInput = ({
  label,
  value,
  onChange,
  disabled,
}: {
  label: string;
  value: number | null;
  onChange: (percentage: number | null) => void;
  disabled?: boolean;
}) => (
  <AdminInput
    label={label}
    placeholder="0 - 100"
    $textCenter
    disabled={disabled}
    value={value ?? ''}
    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
      handleChangeNumInputNoDecimalsMinMax(
        e,
        (raw: string) => onChange(raw === '' ? null : Number(raw)),
        0,
        100
      )
    }
  />
);
